import { render, staticRenderFns } from "./folder-media-grid.vue?vue&type=template&id=ff99387c"
import script from "./folder-media-grid.vue?vue&type=script&lang=js"
export * from "./folder-media-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../_themes/ortus-2019/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports